export default {
  payWelfareText: 'Zalety doładowania',
  blackFridayDiscount: 'Zniżka czasowa z okazji Black Friday',
  shareGift: 'Podziel się prezentem',
  vipWeeklyWelfare: 'Tygodniowa zniżka VIP',
  exchangeCoupon: 'Kupon',
  firstPayOff: 'Do 15% zniżki na pierwszy zakup',
  blackFridayEvent: 'Wydarzenie Black Friday',
  limitedTimeOff: 'Ograniczona czasowo zniżka 10%',
  claimCoupon: 'Odbierz teraz',
  blackFridayTimedCoupon: 'Kupon czasowy Black Friday',
  timeLeft: 'Pozostały czas: ',
  claimTimeCoupon: 'Odbierz kupon 10% zniżki już teraz!',
  points: 'Punkty: ${point}',
  costPointTip: 'Wymieniaj punkty na kupony',
  maxPointTip: 'Każde konto może wykorzystać do 500 punktów.',
  discountOff: '10% zniżki',
  highestDiscount: 'Do ${discount} zniżki',
  needPoint: 'Wymaga ${point} pkt',
  changeCurrency: 'Zmień walutę',
  claim: 'Odbierz',
  claimSucc: 'Odebrano',
  claimFail: 'Porażka',
  pointNotEnough: 'Za mało punktów',
  afterClaimPoint: 'Pozostałe punkty: ${point}',
  footTips1: 'Do każdego zamówienia można wykorzystać tylko 1 kupon.',
  footTips2: 'Kuponu nie można wykorzystać do zakupu walut/tokenów w grze.',
  footTips3:
    ' Zastrzegamy sobie prawo do ostatecznej interpretacji tego wydarzenia.',
  ruleTitleText: 'Zasady wydarzenia',
  ruleTime:
    'Czas trwania wydarzenia: 00:00 24 listopada 2023 r. do 23:59 26 listopada 2023 r. (UTC)',
  bfRuleText1:
    '1. 400 punktów zostanie przyznanych na konto użytkownika po pierwszym zalogowaniu się na oficjalnej stronie doładowania podczas wydarzenia. Można wymienić do 500 punktów na kupony.',
  bfRuleText2:
    '2. Punkty Black Friday można wymieniać na kupony podczas wydarzenia.',
  bfRuleText3:
    '3. Do każdego zamówienia można użyć tylko 1 kuponu. Kuponów nie można wykorzystać do zakupu walut/tokenów w grze.',
  bfRuleText4: '4. W przypadku transakcji akceptujemy tylko następujące waluty:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Nie można zmienić waluty po dokonaniu transakcji. Wymienione punkty nie podlegają zwrotowi.',
  bfRuleText6: '6. Kupony Black Friday są ważne tylko przez 7 dni.',
  bfRuleText7:
    '7. Zastrzegamy sobie prawo do ostatecznej interpretacji tego wydarzenia.',
  thanksTip:
    'Dziękujemy za udział. Dołącz do naszej oficjalnej społeczności, aby uzyskać więcej informacji o wydarzeniu.',
  exchangePoints: 'Wymień',
  exchangeCode: 'Wpisz kod wymiany.',
  enterExchangeCode: 'Wpisz kod wymiany.',
  exchangeText: 'Wymień',
  confirmGet: 'Potwierdź',
  couponUsedWay:
    'Kupon można wykorzystać tylko w określonych walutach, prosimy o potwierdzenie waluty.',
  confirmText: 'Potwierdź',
  exchangeSucc: 'Wymieniono',
  aboutCoins: 'Informacje o walutach/tokenach w grze',
  aboutCoinsText:
    'Waluty/tokeny w grze można wymieniać na wszystkie pakiety i przywileje z wyjątkiem samej waluty/tokena w grze.',
  known: 'OK',
  codeText: 'Kod',
  codeInvalid: 'Nieprawidłowy kod!',
  hasExchanged: 'Nie można ubiegać się o więcej kodów.',
  hideText: 'Ukryj',
  //黑五的报错码
  'bf-20001': 'Niezalogowany',
  'bf-20002': 'Błąd parametru. Spróbuj ponownie wziąć udział w wydarzeniu.',
  'bf-20003': 'Za mało punktów',
  'bf-20004':
    'Nie udało się! Spróbuj ponownie później lub skontaktuj się z działem obsługi klienta.',
  'bf-20005': 'Odebrano',
  'bf-20015': 'Wydarzenie jest obecnie niedostępne.',
  'bf-20016': 'Wydarzenie się zakończyło.',
  bfShareText: 'Odbierz kupon 10% zniżki już teraz!',
  rightsCenterBtn: 'Centrum członków premium',
  payBtn: 'Płatność',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Glorious Extraordinaire (Permanent)',
  rightCenterNoticeTitle: 'System Punktów VIP zostaje przekształcony w Centrum Przywilejów',
  rightCenterNoticeContent: 'Greetings, Commander!<br />Thank you for your supporting Puzzles & Survival. To bring you an even better rewards experience, the current VIP Point System will be upgraded to the all-new Premium Member Center on July 16, 2025. This new system will not only consolidate existing VIP benefits but also introduce a host of exciting new perks. Here\'s what you need to know:<br />1. What\'s Changing?<br />Weekly Log in Benefits Remain<br />From July 16 to 29, 2025, players can continue to claim Weekly VIP Coupons by logging in to the Official Top-up Page. The number of coupons will remain the same as in the VIP Point event. Meanwhile, players will also be able to redeem new coupons in the Premium Member Center, which will include a maximum discount cap. For more details on the new coupon rules and redemption limits, refer to the table at the end of this notice.<br />Note: The automatic coupon redemption feature must be manually enabled. To do so, go to: Privilege Center Homepage > Member Benefits > Enable Auto Redeem Coupons > Select Coupons to Auto-Redeem > Confirm.<br />New Points Exchange Feature<br />The Privilege Center will offer a Points Exchange feature. Earn points by logging in to the game or completing designated tasks. Points can be exchanged for exclusive coupons, rare items, and other valuable rewards. (See the Privilege Center page for item redemption limits.)<br />VIP Level Inheritance<br />Your current VIP level and accumulated VIP Points will be fully transferred to the new system. You\'ll automatically be assigned the corresponding Privilege Center tier, and all your current VIP benefits will be retained and further enhanced under the new system.<br />2. Why This Upgrade Is Better<br />Clearer Benefits: All reward rules and redemption details are clearly displayed, making it easier to claim your benefits.<br />Greater Rewards: Enjoy new point exchange events and regularly updated high-value items.<br />Lucky Draws: In addition to points exchange, prize draw events will also be available, giving you chances to win valuable in-game items.<br />3. Important Notes<br />During the transition period (July 16 to 29, 2025), the original VIP Points section will be gradually phased out. You will still be able to receive and use coupons as usual during this time. Be sure to use any remaining coupons before the VIP Points Event ends. Unused coupons will expire.<br />After the Privilege Center goes live, you can access it by going to Official Top-up Center > Tap Avatar > Privilege Center',
  rightCenterNoticeTableTitle: 'Porównanie zmian kuponów',
  rightCenterNoticeTableHeader1: 'Wymagania dotyczące realizacji - Poziom członkostwa Premium',
  rightCenterNoticeTableHeader2: 'Oryginalny Poziom VIP',
  rightCenterNoticeTableHeader3: 'Zniżka na kupon',
  rightCenterNoticeTableHeader4: 'Limit zakupu',
  rightCenterNoticeTableHeader5: 'Limit maks. zniżki',
  rightCenterNoticeTableLevel1: 'Brąz',
  rightCenterNoticeTableLevel2: 'Srebro', 
  rightCenterNoticeTableLevel3: 'Złoto',
  rightCenterNoticeTableLevel4: 'Platyna',
  rightCenterNoticeTableLevel5: 'Diament',
  rightCenterNoticeTableCount1: 'Raz dziennie',
  rightCenterNoticeTableCount2: '15 razy / miesiąc',
  rightCenterNoticeTableCount3: '10 razy / miesiąc',
  rightCenterNoticeTableLimit: '$15',
  rightCenterNoticeTableTip: 'Uwaga: Limity zniżek kuponów w Centrum Przywilejów są oparte na USD i mogą się zmieniać wraz z kursem wymiany walut. Rzeczywista kwota zniżki zostanie wyświetlona na stronie użycia.',
  '-': '-'
};
